import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import { AccessibilityHtmlTags } from '../../utils/accessibility/constants';
import calendarSettingsParams, {
  ISettingsParams,
  typedSettingsParam,
} from '../BookingCalendar/settingsParams';

type CalendarWidgetSettingsOverride = Pick<
  ISettingsParams,
  'headerTitleHtmlTag' | 'sectionHeaderHtmlTag'
>;

export const calendarWidgetSettingsParamsDefinitions = {
  headerTitleHtmlTag: typedSettingsParam(
    DataType.text,
    SettingsParamType.String,
    AccessibilityHtmlTags.SecondaryHeading,
  ),
  sectionHeaderHtmlTag: typedSettingsParam(
    DataType.text,
    SettingsParamType.String,
    AccessibilityHtmlTags.ThirdHeading,
  ),
};

const calendarWidgetSettingsParams =
  createSettingsParams<CalendarWidgetSettingsOverride>(
    calendarWidgetSettingsParamsDefinitions,
  );

export default {
  ...calendarSettingsParams,
  ...calendarWidgetSettingsParams,
};
